const minin = {
  data() {
    return {
      baseUrl: 'declaration',
      viewMode: false,
      form: {},
      formCtrl: [
        {
          label: "货物名称",
          keyName: "product",
          type: "select",
          err: "请选择货物名称",
          options: [],
        },
        {
          label: "计价方式",
          keyName: "pricing_name",
          type: "select",
          options: [],
        },
        {
          label: "下单量",
          keyName: "quantity",
          err: "请填写下单量",
          type: "text",
        },

        {
          label: "装货地址",
          keyName: "coaddress",
          err: "请填写装货地址",
          type: "text",
        },
        {
          label: "装货联系人",
          keyName: "drman",
          err: "请填写装货联系人",
          type: "text",
        },
        {
          label: "联系电话",
          keyName: "drtel",
          err: "请填写联系电话",
          type: "text",
        },

        {
          label: "卸货地址",
          keyName: "enaddress",
          err: "请填写卸货地址",
          type: "text",
        },
        {
          label: "卸货联系人",
          keyName: "enman",
          err: "请填写卸货联系人",
          type: "text",
        },
        {
          label: "联系电话",
          keyName: "ertel",
          err: "请填写联系电话",
          type: "text",
        },

        {
          ...this.ctrls.ZhuangHuoRiQi,
        },
        {
          ...this.ctrls.XieHuoRiQi,
        },
      ],
      rules: {
        product: [
          { required: true, message: "请选择货物名称", trigger: "blur" },
        ],
        pricing_id: [
          { required: true, message: "请选择计价方式", trigger: "blur" },
        ],
        pricing_name: [
          { required: true, message: "请选择计价方式", trigger: "blur" },
        ],
        quantity: [
          { required: true, message: "请填写下单量", trigger: "blur" },
        ],

        drman: [
          { required: true, message: "请填写装货联系人", trigger: "blur" },
        ],
        drtel: [
          { required: true, message: "请填写正确联系电话", validator: this.checkPhone, trigger: "blur" },
        ],
        coaddress: [
          { required: true, message: "请填写装货地址", trigger: "blur" },
        ],
        enman: [
          { required: true, message: "请填写卸货联系人", trigger: "blur" },
        ],
        ertel: [
          { required: true, message: "请填写正确联系电话", validator: this.checkPhone, trigger: "blur" },
        ],
        enaddress: [
          { required: true, message: "请填写卸货地址", trigger: "blur" },
        ],
        predict_loading_date: [
          { required: true, message: "请填写装货日期", trigger: "blur" },
        ],
        predict_unloading_date: [
          { required: true, message: "请填写卸货日期", trigger: "blur" },
        ],
      },
      product: [],
      custom: [],
      pricing: [],
    };
  },
  methods: {
    setDetail() {
      if (this.detail) {
        this.form = {
          ...this.form,
          ...this.detail,
        }
      }
      
      this.setPricingName()
      // console.log('detail', { ...this.detail })
      // console.log('form', { ...this.form })
    },

    setOptions({
      product,
      // custom,
      pricing
    }) {
      // if (custom && custom.length) {
      //   this.custom = [...custom]
      // }

      this.formCtrl.map(c => {
        if (c.label == '计价方式' && pricing && pricing.length) {
          this.pricing.push(...pricing)
          c.options = pricing.map(v => {
            return {
              label: v.name,
              value: v.name,
            }
          })

          const { pricing_id } = this.detail
          if (!pricing_id) {
            this.$set(this.form, 'pricing_id', pricing[0]['id'])
            this.$set(this.form, 'pricing_name', pricing[0]['name'])
          } else {
            this.setPricingName()
          }
        } if (c.keyName == 'product' && product && product.length) {
          this.product = [...product]
          c.options = product.map(v => {
            return {
              label: v.name,
              value: v.name,
            }
          })
        }
      })
    },

    setPricingName(pricingId) {
      if (!this.detail['pricing_id']) {
        console.log('detail 还未获取到')
      }
      if (!this.pricing) {
        console.log('pricing 还未获取到')
      }
      const pricing_id = pricingId || this.detail['pricing_id']
      if (pricing_id && this.pricing && this.pricing.length) {
        this.pricing.map(v => {
          if (v.id == pricing_id) {
            this.$set(this.form, 'pricing_name', v['name'])
            if (!this.form['pricing_id']) {
              this.form['pricing_id'] = pricing_id
            }
          }
        })
      }
    },

    formOrtherValidate() {
      let boo = true
      const { predict_loading_date, predict_unloading_date } = this.form
      if (new Date(predict_loading_date).getTime() > new Date(predict_unloading_date).getTime()) {
        this.$message({
          type: 'error',
          message: '装货日期不能晚于卸货日期！'
        });
        boo = false
      }
      return boo
    },

    onChange({ key, value }) {
      // console.log('onChange', key, value)
      // console.log(Number(value))
      if (key === 'product') {
        // console.log('onChange', key, value)
        this.$set(this.form, key, value)
        this.product.map(v => {
          if (v.name === value) {
            this.$set(this.form, 'p_id', v.id)
          }
        })
        // console.log(this.form[key])
      } else if (key === 'predict_loading_date') {
        // console.log('onChange', key, value)
        this.$set(this.form, key, value)
        // this.formCtrl.map(v => {
        //   if (v.keyName === 'predict_unloading_date') {
        //     v.pickerOptions = {
        //       disabledDate: (time) => {
        //         return time.getTime() < new Date(value).getTime()
        //       }
        //     }
        //   }
        // })
        // console.log(this.form[key])
      } else {
        this.$set(this.form, key, value)
      }
      // console.log('form', { ...this.form });
    },

  },
  mounted() {
    this.getOptions({ userid: this.user.id })
  },
}

export default minin